'use strict';

var DateService = {
  age: function (birthday) {
    if (!birthday) {
      return '';
    }
    var _birthday = new Date(birthday);
    var ageDifMs = Date.now() - _birthday.getTime();
    var ageDate = new Date(ageDifMs);
    return Math.abs(ageDate.getUTCFullYear() - 1970);
  },

  dateNoGMT: function (dateStr) {
    if (!dateStr) {
      return '';
    }

    if (
      /MSIE /gi.test(window.navigator.userAgent) ||
      /Apple Computer/i.test(navigator.vendor || '')
    ) {
      return new Date((dateStr + '').replace('+0000', ''));
    }

    if (/\d{3}Z?$/.test(dateStr)) {
      return new Date(dateStr);
    }
    return new Date(dateStr + '.000Z');
  }
};

module.exports = DateService;
